const url = "https://yuhuidc.cn:8080/minshizhuan/";


const baseUrl = {
    mgrUserInf: url + 'mgr/user-inf',
    mgrArticleInf: url + 'mgr/article-inf',
    mgrRoleInf: url + 'mgr/role-inf',
    mgrLimitInf: url + "mgr/limit-inf",
    mgrRoleLimit: url + "mgr/role-limit",
    mgrReservation: url + "mgr/reservation-inf",
    mgrFrontNavigation: url + "mgr/front-navigation",
    mgrRotationChart: url + "/mgr/rotation-chart"
};

export default baseUrl;
